
import * as Msdyn365 from '@msdyn365-commerce/core';
import { getSelectedProductIdFromActionInput } from '@msdyn365-commerce-modules/retail-actions';
import { getProductCustomerPricesAsync } from '../dataActions/DataActionExtension.g';
import { IGetProductCustomerPricesResponse } from '../dataActions/DataServiceEntities.g';


export class GetProductCustomerPricesInput implements Msdyn365.IActionInput {
    public productId: number;
    public custAccount: string | undefined;

    constructor(productId: number, custAccount: string | undefined) {
        this.productId = +productId;
        this.custAccount = custAccount;
    }

    public getCacheKey = () => this.productId.toString()+this.custAccount;
    public getCacheObjectType = () => 'GetProductCustomerPrices';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

const createInput = (inputData: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    const productId = getSelectedProductIdFromActionInput(inputData);
    const custAccount = inputData.requestContext.user.customerAccountNumber;

    if (productId) {
        return new GetProductCustomerPricesInput(+productId, custAccount);
    }

    throw new Error(
        'GetProductCustomerPricesInput input cannot be built, no productId or customer account found on module config or query');
};

async function action(input: GetProductCustomerPricesInput, ctx: Msdyn365.IActionContext): Promise<IGetProductCustomerPricesResponse> {
    const custAccount = input.custAccount ?? '';
    const response = await getProductCustomerPricesAsync({ callerContext: ctx }, input.productId, custAccount);

    return response;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetProductCustomerPricesResponse>>action,
    id: 'GetProductCustomerPrices',
    input: createInput
});
